
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockEnquiryGrid extends Serenity.EntityGrid<StockEnquiryRow, any> {
        protected getColumnsKey() { return 'Inventory.StockEnquiry'; }
        protected getDialogType() { return StockEnquiryDialog; }
        protected getIdProperty() { return StockEnquiryRow.idProperty; }
        protected getInsertPermission() { return StockEnquiryRow.insertPermission; }
        protected getLocalTextPrefix() { return StockEnquiryRow.localTextPrefix; }
        protected getService() { return StockEnquiryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}